var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 97.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-3{fill:#7eb3cf}.cls-4{fill:#6da8c7}.cls-5{fill:#86bfdc}.cls-9{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.6 9.32c40.06 20.48-.88 72.3-41.61 84.26S-4.06 93.75.54 48s63-59.16 103.06-38.68z",
    opacity: 0.1,
    fill: "#629fe2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.7,
    cy: 26.68,
    r: 3.45,
    fill: "#e23b3b"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 58.7,
    cy: 26.68,
    r: 3.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M79.19 16.79s-3.22-2.64-21 10.94c11.81-5.58 24.7-4.3 21-10.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.91 17.73A18.5 18.5 0 0167 24.59a62.67 62.67 0 00-6.25 2c.53-.56 1.19-1.31 1.93-2.21a63.42 63.42 0 0111.23-6.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58.18 27.73s17.63-2.19 21-10.94a8 8 0 012.68 4.87C77 32.32 58.18 27.73 58.18 27.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.68 16.79s7.68-2.67 21 10.94c-13.74-6.16-24.68-4.3-21-10.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M56.65 26.86c-1.21-.48-2.38-.91-3.52-1.29A22.74 22.74 0 0145.44 18a35.89 35.89 0 019.29 6c.75 1.22 1.43 2.2 1.92 2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58.69 27.73s-17.63-2.19-21-10.94A8 8 0 0035 21.66c4.91 10.66 23.69 6.07 23.69 6.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.5 2.71s8.23 2.2 6.13 25.13C56.82 10.11 43.72 7.26 52.5 2.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58.63 27.84S47.21 14.08 52.5 2.71a12.53 12.53 0 00-6.41 3.35c-5.85 14.38 12.54 21.78 12.54 21.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.85 3.73s-8.45 1.1-9.37 24.11C62.59 10.5 76 9.39 67.85 3.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58.48 27.84S71.6 15.69 67.85 3.73a12.49 12.49 0 015.91 4.16c3.92 15.03-15.28 19.95-15.28 19.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 83.44L101.59 31l-82.87 1.39 3.13 51a3.29 3.29 0 003.28 3.09H94.7a3.3 3.3 0 003.3-3.04z",
    fill: "#629fe2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 40.09l.62-9.08-82.9 1.38.8 13C34.48 35.51 96.84 40 101 40.09z",
    fill: "#0b6fd5",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 27.2l83.16.14a1.93 1.93 0 011.92 2L103.42 41a1.55 1.55 0 01-1.58 1.46L18.56 41A1.55 1.55 0 0117 39.42V29.13a1.93 1.93 0 012-1.93z",
    fill: "#2a7cdd"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M60.86 27.6a19.46 19.46 0 013.92 4.4 16.81 16.81 0 012.29 5.45 15.57 15.57 0 01.19 6 11.75 11.75 0 01-.88 2.91 4.48 4.48 0 01-2.18 2.38.5.5 0 11-.39-.92h.06a3.69 3.69 0 001.73-1.83 11 11 0 00.93-2.66 15.33 15.33 0 000-5.73 16.67 16.67 0 00-2-5.42 19.53 19.53 0 00-3.67-4.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M60.79 86.5l1-59.32h-6.17V86.5h5.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.45 58.44a12.6 12.6 0 11-12.6-12.6 12.6 12.6 0 0112.6 12.6zM64 46.07c-1.23-.17-2.94 2.07-3.1 3.23a2.2 2.2 0 002 2.41c1.22.17 4.58-.74 4.74-1.91s-2.45-3.57-3.64-3.73z",
    fill: "#0a528e",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.16 57.94a12.6 12.6 0 11-12.6-12.6 12.6 12.6 0 0112.6 12.6zm-12-12.09c-.7-.1-1.78 1.91-1.91 2.92a1.8 1.8 0 001.29 2 2.46 2.46 0 002.12-1.9c.14-.99-.78-2.93-1.49-3.02z",
    fill: "#e53232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.38 57.21a12.6 12.6 0 11-12.6-12.6 12.6 12.6 0 0112.6 12.6zM64.25 46.39c-.7-.1-1.38.65-1.52 1.67s.33 1.92 1 2 1.39-.66 1.52-1.67-.25-1.91-1-2z",
    fill: "#ff4f48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.49 54.9v.28c-.13 1.69-.29 3.39-.38 5.09a5.9 5.9 0 01-2 4.24 10.44 10.44 0 01-3.58 2.08.36.36 0 01-.23 0 10.64 10.64 0 01-3.79-3.64 5.77 5.77 0 01-.82-3.53c.15-1.78.28-3.56.41-5.34v-.49a30 30 0 005.35-.89.79.79 0 01.4 0 33.79 33.79 0 004 2z",
    fill: "#cfefff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M69.48 55v.3c-.14 1.79-.31 3.58-.4 5.37a6.25 6.25 0 01-2.14 4.48 10.94 10.94 0 01-3.78 2.2.33.33 0 01-.24 0 11.13 11.13 0 01-4-3.84 6 6 0 01-.92-3.78c.16-1.88.29-3.76.43-5.64v-.27a29.28 29.28 0 005.44-.82.79.79 0 01.43 0 37.21 37.21 0 004.48 1.77c.22.08.45.13.7.23zM54.64 26.19a14 14 0 00-2.34 6.92 17.32 17.32 0 001.13 7.2 14.74 14.74 0 004 6A7.92 7.92 0 0060.51 48a5.48 5.48 0 003.35-.21.5.5 0 01.65.28.5.5 0 01-.28.65 6.4 6.4 0 01-3.94.12 8.86 8.86 0 01-3.32-2 15.24 15.24 0 01-4-6.35 17.69 17.69 0 01-.91-7.39 14.19 14.19 0 012.58-6.91z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 58.7,
    cy: 27.18,
    r: 3.08
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductService);
export default __webpack_public_path__ + "static/media/productService.9e02e8d4409aaf48d0207467fda43b7e.svg";
export { ForwardRef as ReactComponent };